/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type CrossWorkerDocsImportDocCreateRequest = {} | null | undefined;
export type CrossWorkerDocsImportDocCreateResponse = any;

export type CrossWorkerDocsImportDocCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/cross_worker_docs/{id}/import_doc/
 *
 * ```yaml
 * operationId: cross_worker_docs_import_doc_create
 * tags:
 *   - cross_worker_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const crossWorkerDocsImportDocCreateOperation = ({
  id,
  ...rest
}: CrossWorkerDocsImportDocCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/cross_worker_docs/${id}/import_doc/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/cross_worker_docs/{id}/import_doc/' };
  };

/**
 * POST /dmx-server/cross_worker_docs/{id}/import_doc/
 *
 * ```yaml
 * operationId: cross_worker_docs_import_doc_create
 * tags:
 *   - cross_worker_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const crossWorkerDocsImportDocCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: CrossWorkerDocsImportDocCreateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = crossWorkerDocsImportDocCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
